import { useMemo } from 'react';

import { PickupParkingFacilityDetailContent } from '@/components/map/details/content/PickupParkingFacilityDetailContent';
import { DetailPopup } from '@/components/map/details/popup/DetailPopup';
import { pickupParkingFacilityFeatureCollection } from '@/data/pickupParkingFacilityFeatureCollection';
import { FeatureType } from '@/types/FeatureType';
import { MapLayer } from '@/types/MapLayer';

interface PickupParkingFacilityPopupProps {
  id: string;
}

export function PickupParkingFacilityPopup({ id }: PickupParkingFacilityPopupProps) {
  const pickupParkingFacilityFeature = useMemo(
    () => pickupParkingFacilityFeatureCollection.features.find((feature) => feature.properties.id === id),
    [id],
  );

  if (!pickupParkingFacilityFeature) {
    return null;
  }

  return (
    <DetailPopup
      id={id}
      mapLayer={MapLayer.PICKUP_PARKING_FACILITY}
      point={pickupParkingFacilityFeature.geometry}
      title={pickupParkingFacilityFeature.properties.featurename}
      type={FeatureType.PICKUP_PARKING_FACILITY}
    >
      <PickupParkingFacilityDetailContent facility={pickupParkingFacilityFeature} />
    </DetailPopup>
  );
}
